import { useState } from "react";
import { Link } from "react-router-dom";
import { faqItems } from "@/mocks/homeData";

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section className="w-full bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于爱情岛网址的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              className="rounded-2xl bg-background-100 overflow-hidden"
            >
              <button
                onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="font-medium text-foreground-900 text-sm md:text-base pr-4">
                  {faq.question}
                </span>
                <span
                  className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg transition-all duration-200 ${
                    openId === faq.id
                      ? "bg-primary-100 text-primary-600 rotate-45"
                      : "bg-background-200 text-foreground-500"
                  }`}
                >
                  <i className="ri-add-line text-lg"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === faq.id ? "max-h-96 pb-5 px-5" : "max-h-0"
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/faq"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多常见问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}